export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-8.80300245.png";